var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBloodLocationIcon = function SvgBloodLocationIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.238 8.5c0 2.207-2.593 5.692-3.893 7.3a.926.926 0 0 1-1.451 0C7.594 14.192 5 10.707 5 8.5c0-2.946 2.068-5.167 4.62-5.167 2.55 0 4.618 2.221 4.618 5.167Z",
    stroke: "#767676",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 10a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z",
    stroke: "#767676",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgBloodLocationIcon;